import { Stack } from "@mui/material";
import PropTypes from "prop-types";

import InvoiceSearchCard from "./invoiceSearchCard";

const InvoiceSearchCards = ({ invoices, dispatch, isPoSummary }) => {
    return (
        <Stack spacing={2}>
            {invoices.map((invoice) => (
                <InvoiceSearchCard
                    key={invoice.id}
                    invoice={invoice}
                    dispatch={dispatch}
                    isPoSummary={isPoSummary}
                />
            ))}
        </Stack>
    );
};

InvoiceSearchCards.propTypes = {
    invoice: PropTypes.object,
    dispatch: PropTypes.func,
    isPoSummary: PropTypes.bool,
};

export default InvoiceSearchCards;
